<template>
  <ConfirmationModal
    bodyText=""
    cancelText=""
    continueText="ok"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
  >
    <strong>Status</strong>
    <p>{{ status }}</p>
    <strong>Status Details</strong>
    <p>
      <MarkdownBlock :mdTemplate="details" />
    </p>
    <strong>Status Code</strong>
    <p>{{ code }}</p>
    <strong>Installed Software Version</strong>
    <p>{{ updatedVersion }}</p>
    <strong>Timestamp</strong>
    <p>{{ formattedTimestamp }} (UTC)</p>
  </ConfirmationModal>
</template>

<script>
import { MarkdownBlock } from '@jumpcloud/ui-components';
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'ViewSoftwareAppStatusButtonConfirmationModal',

  components: {
    ConfirmationModal,
    MarkdownBlock,
  },

  props: {
    code: {
      type: String,
      required: true,
    },
    details: {
      type: String,
      required: true,
    },
    formattedTimestamp: {
      type: String,
      required: true,
    },
    handleCancel: {
      type: Function,
      default: () => ModalEventBus.close(),
    },
    handleContinue: {
      type: Function,
      default: () => ModalEventBus.close(),
    },
    headerText: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    updatedVersion: {
      type: String,
      required: true,
    },
  },
};
</script>
